import React, { createContext, useContext, useEffect, useRef } from 'react';
import posthog from 'posthog-js';

const PosthogContext = createContext(null);

export function PosthogProvider({ apiKey, apiHost, options, children }) {
  const isInitialized = useRef(false);

  useEffect(() => {
    if (!isInitialized.current && apiKey) {
      posthog.init(apiKey, {
        api_host: apiHost,
        ...options
      });
      isInitialized.current = true;
    }

    // Cleanup on unmount
    return () => {
      if (isInitialized.current) {
        posthog.reset();
        isInitialized.current = false;
      }
    };
  }, [apiKey, apiHost, options]);

  return (
    <PosthogContext.Provider value={posthog}>
      {children}
    </PosthogContext.Provider>
  );
}

export function usePosthog() {
  const posthogInstance = useContext(PosthogContext);
  if (!posthogInstance) {
    throw new Error("usePosthog must be used within a PosthogProvider");
  }
  return posthogInstance;
}
